import {getStore} from '../../../store-factory';

export const getIsPinTransferEnabled = serviceName => {

    const state = getStore().getState();

    const entitlements = state.user.entitlements;

    const isPinTransferEnabled = entitlements && entitlements.some(service => {

        if (service.key === serviceName && service.value === 'true') {

            return true;

        }
        return false;

    });

    return isPinTransferEnabled;

};



// WEBPACK FOOTER //
// ./src/product/shared/services/get-is-pin-transfer-enabled-aor.js